import React from "react";
import { Helmet } from "react-helmet-async";
import { Mail, LifeBuoy, Linkedin, Facebook } from "lucide-react";
import EdgeFlowers from "../EdgeFlowers";
import "./ContactPage.css";

// Public contact page: who to email, and for what. The wildflower frame is the
// same cut-paper art the game screens use, so the page sits in the meadow too.
const CONTACTS = [
  {
    key: "general",
    Icon: Mail,
    title: "General information",
    blurb: "Questions about MendGrove, our exercises, or your account.",
    email: "info@mendgrove.com",
  },
  {
    key: "support",
    Icon: LifeBuoy,
    title: "Technical support",
    blurb: "Something not working? Tell us what happened and we'll help.",
    email: "support@mendgrove.com",
  },
];

// Social links. Icon-only, so each needs an aria-label to have an accessible
// name. Add a platform by adding an entry — e.g. Facebook: lucide-react ships a
// `Facebook` glyph, so it's an import plus one line here, no CSS.
const SOCIALS = [
  {
    key: "linkedin",
    Icon: Linkedin,
    label: "MendGrove on LinkedIn",
    href: "https://www.linkedin.com/company/mendgrove",
  },
  {
    key: "facebook",
    Icon: Facebook,
    label: "MendGrove on Facebook",
    href: "https://www.facebook.com/mendgrove",
  },
];

const ContactPage = () => (
  <div className="contact-page">
    <Helmet>
      <title>Contact – MendGrove</title>
      <meta
        name="description"
        content="Get in touch with the MendGrove team. Email info@mendgrove.com for general enquiries or support@mendgrove.com for technical support."
      />
    </Helmet>

    <EdgeFlowers />

    <header className="contact-page__header">
      <h1 className="contact-page__title heading-primary">Get in touch</h1>
      <p className="contact-page__sub">
        Reach out to our team for assistance.
      </p>
    </header>

    <ul className="contact-page__cards">
      {CONTACTS.map(({ key, Icon, title, blurb, email }) => (
        <li key={key} className="contact-card">
          <span className="contact-card__icon" aria-hidden="true">
            <Icon size={28} />
          </span>
          <h2 className="contact-card__title heading-tertiary">{title}</h2>
          <p className="contact-card__blurb">{blurb}</p>
          <a className="contact-card__email" href={`mailto:${email}`}>
            {email}
          </a>
        </li>
      ))}
    </ul>

    <ul className="contact-social" aria-label="Follow MendGrove">
      {SOCIALS.map(({ key, Icon, label, href }) => (
        <li key={key}>
          <a
            className="contact-social__link"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
          >
            <Icon size={22} aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default ContactPage;
